import { Stack, Typography } from '@mui/material';
import { ComponentType } from 'react';

import { IconProps } from '@/components/icons/FileSearch02Icon';
import { COLORS } from '@/styles/tokens/colors';

export interface OnboardingValueProp {
  Icon: ComponentType<IconProps>;
  title: string;
  description: string;
}

interface OnboardingValuePropCardsProps {
  valueProps: OnboardingValueProp[];
}

/**
 * The row of icon + title + description cards used on the SmartReview
 * onboarding steps to explain what a feature enables (e.g. document upload,
 * SmartReview). Shared across steps so the layout stays consistent.
 */
export function OnboardingValuePropCards({
  valueProps,
}: OnboardingValuePropCardsProps) {
  return (
    <Stack direction="row" spacing={3} px={5} width="100%">
      {valueProps.map(({ Icon, title, description }) => (
        <Stack
          key={title}
          spacing={1}
          flex="1 0 0"
          alignItems="center"
          textAlign="center"
        >
          <Icon size={24} color={COLORS.BLUE[500]} />
          <Stack spacing={0.5}>
            <Typography variant="title-s">{title}</Typography>
            <Typography variant="body-xs">{description}</Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
